import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@material-ui/core";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { MaterialReactTable } from 'material-react-table';
import { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import PageTitle from '../../../components/PageTitle/PageTitle';
import axios from '../../../utils/axios';
import FundTransferModal from './FundTransferModal';
import SettlementTransferModal from './SettlementTransferModal';
import { Box, Modal } from "@mui/material";
import FundTransferPDFNoteUpload from "./FundTransferPDFNoteUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { IconButton, Tooltip } from "@mui/material";

function FundTransferList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewModalOpen1, setViewModalOpen1] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [modalType, setModalType] = useState("");
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [statusModalData, setStatusModalData] = useState(null);
  const [notes, setNotes] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const currentYear = new Date().getFullYear();

const [paymentDate, setPaymentDate] = useState(today);
const [noteDate, setNoteDate] = useState(today);
const [refNo, setRefNo] = useState(`CMSF/OPE/CASH/${currentYear}`);
const [subject, setSubject] = useState("Settlement of Cash and/or fractional dividend from Capital Market Stabilization Fund (CMSF)");

const [searchRefNo, setSearchRefNo] = useState("All");
const [eftType, setEftType] = useState("All");
const [eftStatus, setEftStatus] = useState("All");
const [startDate, setStartDate] = useState("All");
const [endDate, setEndDate] = useState("All");

const [uploadOpen, setUploadOpen] = useState(false);
const [currentId, setCurrentId] = useState(null);

const [approvalFile, setApprovalFile] = useState(null);
const [eftFile, setEftFile] = useState(null);


const location = useLocation();




  // Fetch fund transfer requests
useEffect(() => {
  
let debounceTimer;
  
    setLoading(true);
    debounceTimer = setTimeout(() => {
      fetchData();
    }, 800); 
  
  return () => clearTimeout(debounceTimer);


  // fetchData();
}, [searchRefNo, eftType, eftStatus, startDate, endDate]);


useEffect(() => {
  // If restoring state, set filters from prevState
  if (location.state?.restoreState) {
    const { searchRefNo, eftType, eftStatus, startDate, endDate } = location.state.prevState;
    setSearchRefNo(searchRefNo);
    setEftType(eftType);  
    setEftStatus(eftStatus);
    setStartDate(startDate);
    setEndDate(endDate);
  }
}, []);

const fetchData = async () => {
  setLoading(true);

  try {
    const query = new URLSearchParams({
      refNo:searchRefNo,
      eftType,
      eftStatus,
      start_date: startDate,
      end_date: endDate,
    }).toString();

    const res = await axios.get(`/fund-transfer-requests?${query}`);

          if (res.data.success) {
          const list = res.data.payload.map((item) => ({
            ...item,
            lastOmcFile: item.omcMinutesFile?.length
              ? item.omcMinutesFile[item.omcMinutesFile.length - 1]
              : null,

            lastEftFile: item.eftNoteFile?.length
              ? item.eftNoteFile[item.eftNoteFile.length - 1]
              : null,
          }));

          setData(list);
         
        }

  } catch (error) {
    console.error("Fetch Error:", error);
  } finally {
    setLoading(false);
  }
};

const handleStartDateChange = (value) => {
  setStartDate(value);

  // Set end date = today by default
  const today = new Date().toISOString().split("T")[0];
  setEndDate(today);
};



  // Handle View Modal Opening
  const handleView = async (id, eftType) => {
    // 🔹 Always reset modal states before opening new one
    setViewModalOpen(false);
    setViewModalOpen1(false);
    setSelectedRequest(null);
    setModalType("");

    try {
      setModalType(eftType);
      const res = await axios.get(`/fund-transfer-requests/${id}?eftType=${eftType}`);
      if (res.data.success) {
        setSelectedRequest(res.data.payload);
        eftType === "General" ? setViewModalOpen(true) : setViewModalOpen1(true);
      }
    } catch (error) {
      console.error("Error fetching fund transfer request details:", error);
      Swal.fire("Error", "Unable to fetch request details", "error");
    }
  };
  
const handleStatusClick = (row) => {
  setStatusModalData(row.original);
  setNotes("");

  // Reset for each click
  setPaymentDate(today);
  setNoteDate(today);
  setRefNo(`CMSF/OPE/CASH/${currentYear}/`);
  setSubject("Settlement of Cash and/or fractional dividend from Capital Market Stabilization Fund (CMSF)");

  setStatusModalOpen(true);
};


const handleStatusUpdate = async () => {
  if (!statusModalData) return;

  const nextStatus =
    statusModalData.eftStatus === "Initiated" ? "Audited" : "Completed";

  try {

    const payload = {
      status: nextStatus,
      note: notes,
      paymentDate: paymentDate,
      refNo: refNo,
      subject: subject,
      noteDate: noteDate,
    
    };

   
    if (statusModalData.eftType === "Cash" && statusModalData.eftStatus === "Initiated") {
      payload.paymentDate = paymentDate;
      payload.refNo = null;
      payload.subject = null;
      payload.noteDate = null;
    }
       if (statusModalData.eftType === "General" ) {
      payload.paymentDate = null;
      payload.refNo = null;
      payload.subject = null;
      payload.noteDate = null;
    }
    if (statusModalData.eftType === "Cash" && statusModalData.eftStatus === "Audited") {
      payload.paymentDate = null;
      payload.refNo = refNo;
      payload.subject = subject;
      payload.noteDate = noteDate;
    }

    const res = await axios.patch(
      `/fund-transfer-requests/${statusModalData.id}`,
      payload
    );

    if (res.data.success) {
      Swal.fire("Success", `Status updated to ${nextStatus}`, "success");
      setStatusModalOpen(false);

      setData((prev) =>
        prev.map((item) =>
          item.id === statusModalData.id
            ? { ...item, eftStatus: nextStatus }
            : item
        )
      );
    }
  } catch (error) {
    console.error("Error updating EFT status:", error);
    Swal.fire("Error", "Unable to update status", "error");
  }
};


const handleOpenUploadModal = (id) => {
  setCurrentId(id);
  setUploadOpen(true);
};


const handleSubmitUpload = async () => {
  if (!approvalFile || !eftFile) {
    Swal.fire("Missing files!", "Please upload both files.", "warning");
    return;
  }

  const formData = new FormData();
 formData.append("settlement_file", approvalFile);
 formData.append("eft_file", eftFile);


  try {
    const res = await axios.put(
      `/fund-transfer-requests/file-upload/${currentId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    Swal.fire("Success!", "Files uploaded successfully.", "success");
    setUploadOpen(false);
    setApprovalFile(null);
    setEftFile(null);
    // Refresh data
    fetchData();
  } 
  
  catch (error) {
 
    Swal.fire("Error!", "Failed to upload files.", "error");
      setUploadOpen(false);
    setApprovalFile(null);
    setEftFile(null);
  }
};



  const columns = [
    {
      accessorKey: 'serialNumber',
      header: 'SL',
      size: 50,
      Cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "date",
      header: "Date",
      size: 50,
    },
    {
      accessorKey: "refNo",
      header: "Reference No",
      size: 50,
    },
   {
  accessorKey: "subject",
  header: "Transfer Type",
  size: 50,
  Cell: ({ row }) => {
    const subject = row.original.subject;

    if (subject === "Electronic Fund Transfer Request.") {
      return "EFT";
    }

    if (subject === "RTGS Fund Transfer Request.") {
      return "RTGS";
    }

    return subject; // fallback if neither matches
  },
},

    {
      accessorKey: "totalAmount",
      header: "Amount",
      size: 50,
    },
     {
      accessorKey: "bouncedAmount",
      header: "Bounced",
      size: 50,
    },
       
     {
        accessorKey: "eftType",
        header: "Type",
        size: 50,
        Cell: ({ row }) => {
        
          return row.original.eftType === "General" ? row.original.eftType : `Settlement (${row.original.eftType})` ;
        },
      },
      {
  accessorKey: "eftStatus",
  header: "Status",
  size: 50,
  Cell: ({ row }) => {
    const status = row.original.eftStatus;
    const auditedNote = row.original.auditedNote;
    const completedNote = row.original.completedNote;

    // Determine tooltip text
    let tooltipText = "";

    if (status === "Audited") {
      tooltipText = auditedNote || "";
    } else if (status === "Completed") {
      tooltipText = completedNote || "";
    }

    const statusElement =
      status === "Completed" ? (
        <span style={{ color: "green", fontWeight: "bold" }}>{status}</span>
      ) : (
        <Button
          size="small"
          variant="outlined"
          color={status === "Initiated" ? "secondary" : "primary"}
          onClick={() => handleStatusClick(row)}
        >
          {status ==="Audited" && row.original.eftType === "Cash" ? "Transferred" : status}
        </Button>
      );

    // If no tooltip needed (Initiated), return without tooltip wrapper
    if (!tooltipText) {
      return statusElement;
    }

    // Wrap with tooltip
    return (
      <Tooltip
        title={tooltipText}
        arrow
        placement="top"
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "12px",
              padding: "6px 10px",
            },
          },
        }}
      >
        <span>{statusElement}</span>
      </Tooltip>
    );
  },
},


{
  accessorKey: "actions",
  header: "Actions",
  Cell: ({ row }) => {
    const canNotify =
      row.original.eftStatus === "Completed" &&
      row.original.eftType === "Cash";

    return (
      <div style={{ display: "flex", gap: "8px" }}>

        {/* View */}
        <Tooltip title="View">
          <IconButton
            color="primary"
            size="medium"
            onClick={() =>
              handleView(row.original.id, row.original.eftType)
            }
          >
            <VisibilityIcon  />
          </IconButton>
        </Tooltip>

        {/* Notify (Enabled only if condition match) */}
        {canNotify ? (
          <Tooltip title="Notify">
            <Link
              to={{
                pathname: `/app/eft/settlementConfirmation/${row.original.id}`,
                state: {
                  refNo: row.original.refNo,
                  amount: row.original.totalAmount,
                  prevState: {
                    searchRefNo,
                    eftType,
                    eftStatus,
                    startDate,
                    endDate,
                  },
                },
              }}
              style={{ textDecoration: "none" }}
            >
              <IconButton
                color="secondary"
                size="medium"
              >
                <NotificationsActiveIcon  />
              </IconButton>
            </Link>
          </Tooltip>
        ) : (
          <Tooltip title="Notify (Not Available)">
            <span>
              <IconButton
                size="medium"
                disabled
              >
                <NotificationsActiveIcon  />
              </IconButton>
            </span>
          </Tooltip>
        )}

        {/* Upload */}
        <Tooltip title="Upload Files">
          <IconButton
            color="success"
            size="medium"
            onClick={() =>
              handleOpenUploadModal(row.original.id)
            }
          >
            <UploadFileIcon  />
          </IconButton>
        </Tooltip>
      </div>
    );
  },
},
  ];

  return (
    <>
   
            <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            style={{ marginBottom: "10px" }}
          >
            {/* Left side: title */}
            <Grid item>
              <PageTitle title="Electronic Beneficiary List" />
            </Grid>

            {/* Right side: buttons in one line */}
            <Grid item>
              <Grid container spacing={2}>
                  <Grid item>
                     <Link to="/app/eft/fundTransferRequest">
                       <Button variant="contained" color="primary" >
               Gerneral Transfer
              </Button>
                  </Link>
                </Grid>
                <Grid item>
                  <Link to="/app/eft/settlementEftRequest">
                    <Button variant="contained" color="primary">
                     Settlement Transfer
                    </Button>
                  </Link>
                </Grid>
              
              </Grid>
            </Grid>
          </Grid>
{/* === FILTER SECTION === */}
<Grid 
  container 
  spacing={2} 
  sx={{ mb: 2, alignItems: "center" }}
>

  {/* Ref No */}
  <Grid item xs={12} sm={6} md={2}>
    <TextField
      fullWidth
      label="Ref No"
      size="small"
      variant="outlined"
      value={searchRefNo === "All" ? "" : searchRefNo}
      onChange={(e) => setSearchRefNo(e.target.value || "All")}
    />
  </Grid>

  {/* EFT Type */}
  <Grid item xs={12} sm={6} md={2}>
    <FormControl fullWidth size="small">
      <InputLabel>EFT Type</InputLabel>
      <Select
        label="EFT Type"
        value={eftType}
        onChange={(e) => setEftType(e.target.value)}
      >
        {["All", "Cash", "General"].map((item) => (
          <MenuItem key={item} value={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>

 
{/* EFT Status */}
<Grid item xs={12} sm={6} md={2}>
  <FormControl fullWidth size="small">
    <InputLabel>Status</InputLabel>
    <Select
      label="Status"
      value={eftStatus}
      onChange={(e) => setEftStatus(e.target.value)}
    >
      <MenuItem value="All">All</MenuItem>
      <MenuItem value="Initiated">Initiated</MenuItem>
      <MenuItem value="Audited">Audited</MenuItem>
      <MenuItem value="Completed">Completed</MenuItem>
    </Select>
  </FormControl>
</Grid>


  {/* Start Date */}
  <Grid item xs={12} sm={6} md={2}>
    <TextField
      fullWidth
      label="Start Date"
      type="date"
      size="small"
      InputLabelProps={{ shrink: true }}
      value={startDate === "All" ? "" : startDate}
      onChange={(e) => handleStartDateChange(e.target.value || "All")}
    />
  </Grid>

  {/* End Date */}
  <Grid item xs={12} sm={6} md={2}>
    <TextField
      fullWidth
      label="End Date"
      type="date"
      size="small"
      InputLabelProps={{ shrink: true }}
      value={endDate === "All" ? "" : endDate}
      onChange={(e) => setEndDate(e.target.value || "All")}
      disabled={startDate === "All"}
    />
  </Grid>

  {/* Reset Button */}
  <Grid item xs={12} sm={6} md={2}>
    <Button
      fullWidth
      variant="contained"
      color="warning"
      onClick={() => {
        setSearchRefNo("All");
        setEftType("All");
        setEftStatus("All");
        setStartDate("All");
        setEndDate("All");
      }}
    >
      Reset
    </Button>
  </Grid>

</Grid>


<MaterialReactTable
  columns={columns}
  data={data}
  state={{ isLoading: loading }}

  enableColumnActions={false}
  enableSorting
  enablePagination

  initialState={{
    density: "compact",
  }}

  // Make rows & cells smaller
  muiTableBodyCellProps={{
    sx: { padding: "1px 2px", fontSize: "13px" },
  }}
  muiTableHeadCellProps={{
    sx: { padding: "1px 6px", fontSize: "13px", fontWeight: "bold" },
  }}
  muiTableBodyRowProps={{
    sx: { height: "34px" },
  }}

  // Make toolbar compact
  muiTopToolbarProps={{
    sx: { minHeight: "34px", padding: "0 6px" },
  }}
  muiBottomToolbarProps={{
    sx: { minHeight: "34px", padding: "0 6px" },
  }}

  // Pagination compact
  muiTablePaginationProps={{
    sx: { fontSize: "12px" },
  }}

  // Optional: Remove thick shadows (clean design)
  muiTablePaperProps={{
    sx: { boxShadow: "none", border: "1px solid #ddd" },
  }}
/>

   
      {modalType === "General" && viewModalOpen && (
        <FundTransferModal
          open={viewModalOpen}
          onClose={() => {
            setViewModalOpen(false);
            setModalType("");
            setSelectedRequest(null);
          }}
          requestData={selectedRequest}
        />
      )}

      {modalType === "Cash" && viewModalOpen1 && (
        <SettlementTransferModal
          open={viewModalOpen1}
          onClose={() => {
            setViewModalOpen1(false);
            setModalType("");
            setSelectedRequest(null);
          }}
          requestData={selectedRequest}
        />
      )}


      <Dialog
      open={statusModalOpen}
      onClose={() => setStatusModalOpen(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {statusModalData?.eftStatus === "Initiated"
          ? "Audit Fund Transfer Request"
          : "Complete Fund Transfer Request"}
      </DialogTitle>


   <DialogContent dividers>
   {statusModalData && (
    <>
      <p><strong>Date:</strong> {statusModalData.date}</p>
            <p><strong>Reference No:</strong> {statusModalData.refNo}</p>
            <p><strong>Subject:</strong> {statusModalData.subject}</p>
            <p><strong>Total Amount:</strong> {statusModalData.totalAmount}</p>
            <p><strong>Bounced Amount: </strong>{statusModalData.bouncedAmount}</p>
      {/* Show extra fields ONLY for Cash */}
      {statusModalData.eftType === "Cash" && statusModalData.eftStatus == "Audited" && (
        <>
      
          {/* Ref No */}
          <TextField
            label="Ref No"
            fullWidth
            margin="normal"
            value={refNo}
            InputProps={{ readOnly: true }}   // 🔒 Read-Only
            required
          />

             {/* Note Date */}
          <TextField
            label="Note Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={noteDate}
            onChange={(e) => setNoteDate(e.target.value)}
            required
          />


          {/* Subject Dropdown */}
          <TextField
            select
            label="Subject"
            fullWidth
            margin="normal"
            SelectProps={{ native: true }}
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          >
            <option value="Settlement of Cash and/or fractional dividend from Capital Market Stabilization Fund (CMSF)">
              Settlement of Cash and/or fractional dividend from Capital Market Stabilization Fund (CMSF)
            </option>
          </TextField>
        </>
      )}

       {statusModalData.eftType === "Cash" && statusModalData.eftStatus == "Initiated" && (
        <>
          {/* Payment Date */}
          <TextField
            label="Payment Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={noteDate}
            onChange={(e) => setNoteDate(e.target.value)}
            required
          />

        </>
      )}


      {/* Notes Field */}
      <TextField
        label="Notes"
        multiline
        fullWidth
        rows={3}
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        variant="outlined"
        margin="normal"
        required={
          statusModalData.eftStatus === "Initiated" ||
          statusModalData.eftStatus === "Audited"
        }
      />
    </>
  )}
</DialogContent>

      <DialogActions>
        <Button onClick={() => setStatusModalOpen(false)} color="default">
          Cancel
        </Button>
        {statusModalData?.eftStatus !== "Completed" && (
          <Button
            onClick={handleStatusUpdate}
            color="primary"
            variant="contained"
          disabled={notes.trim() === ""} // 👈 disables for both statuses if note empty
          >
            {statusModalData?.eftStatus === "Initiated" ? statusModalData?.eftType === "Cash" ? "Transferred": "Audited" : "Completed"}
          </Button>
        )}
      </DialogActions>
    </Dialog>

 <Modal open={uploadOpen} onClose={() => setUploadOpen(false)}>
  <Box
    sx={{
      width: "45%",
      bgcolor: "white",
      p: 4,
      borderRadius: "12px",
      boxShadow: 24,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    }}
  >
    <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
      Upload Required Documents
    </h2>

    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <FundTransferPDFNoteUpload
          label="Approval Note"
          file={approvalFile}
          setFile={setApprovalFile}
          fundTransferId={currentId}
          existingFile={data.find(item => item.id === currentId)?.lastOmcFile}
        />


      <FundTransferPDFNoteUpload
        label="EFT Note"
        file={eftFile}
        setFile={setEftFile}
         fundTransferId={currentId}
          existingFile={data.find(item => item.id === currentId)?.lastEftFile}

      />
    </div>

    <div
      style={{
        textAlign: "right",
        marginTop: "30px",
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
      }}
    >
      <Button
        variant="outlined"
        color="error"
        onClick={() => setUploadOpen(false)}
      >
        Cancel
      </Button>

      <Button
        variant="contained"
        color="success"
        onClick={handleSubmitUpload}
        disabled={!approvalFile || !eftFile}
      >
        Submit
      </Button>
    </div>
  </Box>
</Modal>



    </>
  );
}

export default FundTransferList;
